module.exports = __webpack_public_path__ + "img/132.ea39a127.gif";